import { THEME_LIGHT } from './constants';

export default {
  currentTheme: THEME_LIGHT,
};
